<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-show="type!=3" type="primary" size="mini" :loading="loading" @click="edit(1)") 取消确定
          el-button(v-show="type!=3" type="primary" size="mini" :loading="loading" @click="generate") 生成发货单
          //el-button(v-show="type==3 && head.state==3" type="primary" size="mini" @click="goto('/supply/sales_order_detail_printing/'+head.id)") 打印
          el-button(v-show="type==3 && head.state==1" type="primary" size="mini" :loading="loading" @click="edit(2)") 确认
          el-button(v-show="type==3 && head.state==1" type="primary" size="mini" @click="dialogFormVisible=true") 驳回
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row
        el-col(:span="20")
          div 采购方
      el-form.mt-4(label-width="100px" size="mini")
        el-row
          el-col(:span="7")
            el-form-item(label="订单编号:")
              span {{head.code}}
            el-form-item(label="SAP订单号:")
              span {{head.ebeln}}  
            el-form-item(label="含税总金额:")
              span {{head.taxmoney}}
            el-form-item(label="收货地址:")
              span {{head.address}}
          el-col(:span="7")
            el-form-item(label="采购组织:")
              span {{head.name_buy_org}}
            el-form-item(label="订单日期:")
              span {{head.order_date}}
          el-col(:span="7")
            el-form-item(label="采购员:")
              span {{head.name_buy_person}}
            el-form-item(label="联系方式:")
              span {{head.mobile_buy_person}}
      el-row.mt-5.mb-2
        el-col(:span="20")
          div 供应商
      el-form.mt-4(:model="head" label-width="100px" size="mini")
        el-row
          el-col(:span="7")
            el-form-item(label="供应商")
              span {{head.name_supplier}}
          el-col(:span="7")
            el-form-item(label="联系人")
              span {{head.name_link}}
          el-col(:span="7")
            el-form-item(label="联系电话")
              span {{head.mobile_link}}
      el-row.mt-5
        el-col(:span="20")
          div 物料信息
      el-table(:data="body | filterStatus" style="width: 100%" size="mini" @selection-change="handleSelectionChange")
        el-table-column(v-if="type==2" type="selection" :selectable="checkStatus" width="50" key="selection")
        el-table-column(prop="row_num" label="行号" width="50" key="row_num")
        el-table-column(prop="code_material" label="物料编码" width="150" key="code_material" show-overflow-tooltip)
        el-table-column(prop="name_material" label="物料名称" width="200" key="name_material" show-overflow-tooltip)
        el-table-column(prop="need_person" label="申购人" width="90" key="need_person")
        el-table-column(prop="need_remark" label="申购备注" width="100" key="need_remark" show-overflow-tooltip)
        el-table-column(prop="num" label="数量" width="80" key="num")
        el-table-column(prop="unit_material" label="单位" width="50" key="unit_material")
        el-table-column(prop="trans_date" label="期望到货日期" width="120" key="trans_date")
        el-table-column(prop="unitprice" label="含税单价(元)" width="100" key="unitprice")
        el-table-column(prop="money" label="含税金额(元)" width="100" key="money")
        el-table-column(prop="tax" label="税率(%)" width="70" key="tax")
        el-table-column(prop="name_stock_org" label="需求组织" width="200" key="name_stock_org" show-overflow-tooltip)
        el-table-column(prop="remark" label="备注" key="remark" show-overflow-tooltip)
        el-table-column(prop="dy_num" label="供方已发数量" width="100" key="dy_num")
        el-table-column(v-if="type==2" prop="pre_trans_num" label="可发货量" width="100" key="pre_trans_num")
        el-table-column(prop="stock_num" label="入库数量" key="stock_num")
        el-table-column(prop="sub_stock_num" label="入库差异数量" width="100" key="sub_stock_num")
        el-table-column(prop="pre_rcv_num" label="可收货量" key="pre_rcv_num")
        el-table-column(prop="sign_date" label="签收时间" key="sign_date")
        el-table-column(prop="code_need" label="需求单号" width="200" key="code_need")
        el-table-column(prop="code_nc" label="来源单号" width="200" key="code_nc")
        el-table-column(label="退货" width="50" key="state_front")
          template(slot-scope="scope")
            span {{scope.row.state_front==1?'是':'否'}}
    el-dialog.dialog(title="驳回原因" :visible.sync="dialogFormVisible" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="form" ref="form" size="mini" label-width="60px" :rules="rules")
        el-form-item(label="内容" prop="reason")
          el-input(v-model="form.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 4}")
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormVisible = false") 取 消
        el-button(size="mini" type="primary" @click="submitForm") 确 定
</template>
<script>
export default {
  filters: {
    filterStatus(e) {
      return e.filter((data) => {
        return data.status == 0;
      });
    },
  },
  data() {
    return {
      h: "",
      data: {},
      head: {},
      body: [],
      loading: false,
      items: [
        {
          path: "/supply/sales_order",
          meta: {
            title: "销售订单",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "订单详情",
          },
        },
      ],
      disabled: false,
      rules: {
        name_link: [
          { required: true, message: "请填写联系人", trigger: "blur" },
        ],
        mobile_link: [
          { required: true, message: "请填写联系人手机号", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
      },
      dialogFormVisible: false,
      form: {
        reason: "",
      },
      multipleSelection: [],
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    checkStatus(row, rowIndex) {
      if (parseFloat(row.pre_trans_num) <= 0) {
        return false;
      } else {
        return true;
      }
    },
    async generate() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择需要操作的数据",
          type: "error",
        });
        return false;
      }
      let body = [];
      for (var i in this.multipleSelection) {
        body.push({
          id: this.multipleSelection[i].id,
          modify_date: this.multipleSelection[i].modify_date,
        });
      }
      this.loading = true;
      let res = await this.$api.order.delivery({
        head: { id: this.head.id, modify_date: this.head.modify_date },
        body: body,
      });
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.goto("/supply/invoice");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.head.state = -1;
          this.head.reason = this.form.reason;
          let data = [this.head];
          this.loading = true;
          let res = await this.$api.order.edit(data);
          this.loading = false;
          if (res) {
            this.dialogFormVisible = false;
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        } else {
          return false;
        }
      });
    },
    async edit(type) {
      this.head.state = type;
      let data = [this.head];
      this.loading = true;
      let res = await this.$api.order.edit(data);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    calculation(row) {
      row.money = this.$utils.toDecimal2OrMore(row.num * row.unitprice);
    },
    del(e, index) {
      if (this.ct_pu_pay.length > 1) {
        this.ct_pu_pay.splice(index, 1);
        for (var i in this.ct_pu_pay) {
          this.ct_pu_pay[i].pay_stage = i + 1;
        }
      } else {
        this.$notify({
          message: "只剩一条无法删除",
          type: "error",
        });
      }
    },
    async getById() {
      let res = await this.$api.order.getById(this.id);
      if (res) {
        this.data = res.data;
        this.head = res.data.head;
        this.body = res.data.body;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getById();
    if (this.type == 3) {
      this.disabled = true;
      this.items[1].meta.title = "详情";
    } else {
      this.items[1].meta.title = "发布";
    }
  },
};
</script>